import { useSearch } from '../../../hooks';
import { FilterSet } from '../filter-set';
import { RadiusFilter } from '../radius-filter';
import { ListSalaryFilter } from '../salary-filter';
import { TimeFrameFilter } from '../time-frame-filter';

import * as S from './all-filters.styles';

export const AllFilters: React.FC = () => {
  const {
    aggregations: { filters },
    isLoading,
    results,
  } = useSearch();

  if (!isLoading && !results?.aggregations) {
    return null;
  }

  return (
    <S.Container>
      <S.AppliedFilters isSmallScreen />
      <TimeFrameFilter loading={isLoading} />
      <RadiusFilter />
      {filters.map((filter) => {
        if (filter === 'salary') {
          return <ListSalaryFilter key={filter} />;
        }

        const { titleKey, name } = filter;

        return (
          <FilterSet
            key={titleKey}
            loading={isLoading && !results}
            name={name}
            filter={filter}
            isAllFilters
          />
        );
      })}
    </S.Container>
  );
};
